<template>
<div class="chapter">
<div class="inner_page">
<p class="tx"><a id="page_v"></a></p><a id="page_v">
<p class="tx3"><strong>F<span class="small">OR</span> M<span class="small">Y</span> A<span class="small">GENT</span>,<br/>P<span class="small">ETER</span> R<span class="small">UBIE</span></strong></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?1e144a06